import Helmet from 'react-helmet';
import type { ReactNode, VoidFunctionComponent } from 'react';

import { useIsQualityEnabled } from '../../helpers/features/quality';
import { PolicyType } from '../../types';
import Loader from '../generic/Loader';
import NotFound from '../generic/NotFound';
import type { AsyncStatus } from '../../types';

type ListQualityPoliciesPageProps = {
  renderPolicyList: (policyType: PolicyType) => ReactNode;
  status: AsyncStatus,
};

const ListQualityPoliciesPage: VoidFunctionComponent<ListQualityPoliciesPageProps> = ({
  renderPolicyList,
  status,
}) => {
  const hasQuality = useIsQualityEnabled();

  if (!hasQuality) {
    return <NotFound />;
  }

  return (
    <div className="container margin-top">
      <Helmet title="Policies" />
      {status?.errors?.map(error => <div key={error} className="alert alert-error">{error}</div>)}
      {status?.loading ? <Loader /> : renderPolicyList(PolicyType.QUALITY)}
    </div>
  );
};

export default ListQualityPoliciesPage;
